// This file's entirely about extending native functionality.
/* eslint-disable no-extend-native */

import objectAssign from 'core-js/features/object/assign';

Object.assign = Object.assign || objectAssign;
